import { settingsTypes } from './actions';
import { authTypes } from 'Containers/Auth/store/actions';

const initialState = {
  customerPortal: '',
  bill: {},
  plans: {},
  invoices: {},
  products: {},
  productsLoading: false,
  productsError: null,
  plansLoading: false,
  subscriptionStatus: null,
  subscriptionLoading: false,
  subscriptionSubmitting: false,
  subscriptionError: null,
  accounts: [],
  myAccount: {},
  showTokenExpiredModal: false,
  tokenExpiredModalReason: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case authTypes.SET_ACTIVE_SALON.SUCCESS:
      return {
        ...state,
        products: {},
        productsLoading: false,
        productsError: null,
        subscriptionStatus: null,
        plans: {},
      };
    case settingsTypes.CREATE_CUSTOMER_PORTAL.SUCCESS:
      return {
        ...state,
        customerPortal: action.payload,
      };
    case settingsTypes.GET_CUSTOMER_BILL.SUCCESS:
      return {
        ...state,
        bill: action.payload,
      };
    case settingsTypes.GET_CUSTOMER_PLAN.SUCCESS:
      return {
        ...state,
        plans: action.payload,
        plansLoading: false,
      };
    case settingsTypes.GET_CUSTOMER_PLAN.REQUEST:
      return {
        ...state,
        plansLoading: true,
      };
    case settingsTypes.GET_CUSTOMER_PLAN.FAILED:
      return {
        ...state,
        plansLoading: false,
      };
    case settingsTypes.GET_CUSTOMER_PRODUCTS.REQUEST:
      return {
        ...state,
        productsLoading: true,
        productsError: null,
      };
    case settingsTypes.GET_CUSTOMER_PRODUCTS.FAILED:
      return {
        ...state,
        productsLoading: false,
        productsError: action.payload?.message || 'Impossibile caricare i dati abbonamento',
      };
    case settingsTypes.GET_SUBSCRIPTION_STATUS.REQUEST:
      return {
        ...state,
        subscriptionLoading: true,
        subscriptionError: null,
      };
    case settingsTypes.GET_SUBSCRIPTION_STATUS.SUCCESS:
      return {
        ...state,
        subscriptionStatus: action.payload,
        subscriptionLoading: false,
      };
    case settingsTypes.GET_SUBSCRIPTION_STATUS.FAILED:
      return {
        ...state,
        subscriptionLoading: false,
      };
    case settingsTypes.CREATE_SUBSCRIPTION.REQUEST:
      return {
        ...state,
        subscriptionSubmitting: true,
        subscriptionError: null,
      };
    case settingsTypes.CREATE_SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        subscriptionSubmitting: false,
      };
    case settingsTypes.CREATE_SUBSCRIPTION.FAILED:
      return {
        ...state,
        subscriptionSubmitting: false,
        subscriptionError: action.payload?.message || 'Errore durante la gestione dell\'abbonamento',
      };
    case settingsTypes.GET_CUSTOMER_PRODUCTS.SUCCESS:
      return {
        ...state,
        products: action.payload,
        productsLoading: false,
        productsError: null,
      };
    case settingsTypes.GET_CUSTOMER_INVOICE.SUCCESS:
      return {
        ...state,
        invoices: action.payload,
      };
      case settingsTypes.ACCEPT_TERMS.SUCCESS:
      return {
        ...state,
        products: {...state.products, acceptedTerms: true},
      };
      case settingsTypes.GET_ACCOUNTS_STAFF.SUCCESS:
      return {
        ...state,
        accounts: action.payload,
      };
      case settingsTypes.ADD_ACCOUNT_STAFF.SUCCESS:
      return {
        ...state,
        accounts: [...state.accounts, action.payload],
      };
      case settingsTypes.EDIT_ACCOUNT_STAFF.SUCCESS:
      return {
        ...state,
        accounts: state.accounts.map((account) => {
          if (account.idUtenteBusiness === action.payload.idUtenteBusiness) {
            return action.payload;
          }
          return account;
        }),
      };
      case settingsTypes.DELETE_ACCOUNT_STAFF.SUCCESS:
      return {
        ...state,
        accounts: state.accounts.filter((account) => account.idUtenteBusiness !== action.payload.idUtenteBusiness),
      };
      case settingsTypes.GET_MY_ACCOUNT_STAFF.SUCCESS:
      return {
        ...state,
        myAccount: action.payload,
      };
    case settingsTypes.SHOW_TOKEN_EXPIRED_MODAL.SUCCESS:
      return {
        ...state,
        showTokenExpiredModal: true,
        tokenExpiredModalReason: action.payload?.reason ?? 'tokenExpired',
      };
    case settingsTypes.HIDE_TOKEN_EXPIRED_MODAL.SUCCESS:
      return {
        ...state,
        showTokenExpiredModal: false,
        tokenExpiredModalReason: null,
      };
    default:
      return { ...state };
  }
};
